import { render, staticRenderFns } from "./stockdetail.vue?vue&type=template&id=4ecc1e5e&scoped=true&"
import script from "./stockdetail.vue?vue&type=script&lang=js&"
export * from "./stockdetail.vue?vue&type=script&lang=js&"
import style0 from "./stockdetail.vue?vue&type=style&index=0&id=4ecc1e5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc1e5e",
  null
  
)

export default component.exports